<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col lg="6" cols="7">
          <!-- <h6 class="h2 text-white d-inline-block mb-0">{{ motorbike._name }}</h6> -->
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
        <b-col lg="6" cols="5" class="text-right">
          <router-link :to="{ name: 'newMotorbike' }" class="btn btn-neutral btn-sm">New</router-link>
        </b-col>
      </b-row>
      <!-- Card stats -->
      <b-row >
        <b-col md="6" xl="3" >
          <stats-card title="Total motorbikes"
                      type="gradient-red"
                      :sub-title="String(metrics.motorbikesTwoMonths.thisMonth) + ' motorbikes'"
                      icon="ni ni-key-25">

            <template slot="footer">
              <span class="mr-2" :class="{
                'text-success': metrics.motorbikesTwoMonths.thisMonth > metrics.motorbikesTwoMonths.lastMonth,
                'text-danger': metrics.motorbikesTwoMonths.lastMonth > metrics.motorbikesTwoMonths.thisMonth
              }"><i class="fa" :class="{
                'fa-arrow-up': metrics.motorbikesTwoMonths.thisMonth > metrics.motorbikesTwoMonths.lastMonth,
                'fa-arrow-down': metrics.motorbikesTwoMonths.lastMonth > metrics.motorbikesTwoMonths.thisMonth
              }"></i> {{ metrics.motorbikesTwoMonths.lastMonthPercentage }}%</span>
              <span class="text-nowrap">Since last month</span>
            </template>
          </stats-card>
        </b-col>
        <b-col md="6" xl="3">
          <stats-card title="Distance rode"
                      type="gradient-orange"
                      :sub-title="String(metrics.mileageTwoMonths.thisMonthMeters) + ' km'"
                      icon="ni ni-world-2">

            <template slot="footer">
              <span class="mr-2" :class="{
                              'text-success': metrics.mileageTwoMonths.thisMonth > metrics.mileageTwoMonths.lastMonth,
                              'text-danger': metrics.mileageTwoMonths.lastMonth > metrics.mileageTwoMonths.thisMonth
                            }"><i class="fa" :class="{
                              'fa-arrow-up': metrics.mileageTwoMonths.thisMonth > metrics.mileageTwoMonths.lastMonth,
                              'fa-arrow-down': metrics.mileageTwoMonths.lastMonth > metrics.mileageTwoMonths.thisMonth
                            }"></i> {{ metrics.mileageTwoMonths.lastMonthPercentage }}%</span>
              <span class="text-nowrap">Versus last month</span>
            </template>
          </stats-card>
        </b-col>
        <b-col md="6" xl="3">
          <stats-card title="Days rode"
                      type="gradient-green"
                      :sub-title="String(metrics.daysTwoMonths.thisMonth) + ' days'"
                      icon="ni ni-calendar-grid-58">

            <template slot="footer">
              <span class="mr-2" :class="{
                                            'text-success': metrics.daysTwoMonths.thisMonth > metrics.daysTwoMonths.lastMonth,
                                            'text-danger': metrics.daysTwoMonths.lastMonth > metrics.daysTwoMonths.thisMonth
                                          }"><i class="fa" :class="{
                                            'fa-arrow-up': metrics.daysTwoMonths.thisMonth > metrics.daysTwoMonths.lastMonth,
                                            'fa-arrow-down': metrics.daysTwoMonths.lastMonth > metrics.daysTwoMonths.thisMonth
                                          }"></i> {{ metrics.daysTwoMonths.lastMonthPercentage }}%</span>
              <span class="text-nowrap">Versus last month</span>
            </template>
          </stats-card>

        </b-col>
        <b-col md="6" xl="3">
          <stats-card title="Cost"
                      type="gradient-info"
                      :sub-title="String(metrics.maintenanceCostTwoMonths.thisMonth) + ' €'"
                      icon="ni ni-money-coins">

            <template slot="footer">
              <span class="mr-2" :class="{
                                          'text-danger': metrics.maintenanceCostTwoMonths.thisMonth > metrics.maintenanceCostTwoMonths.lastMonth,
                                          'text-success': metrics.maintenanceCostTwoMonths.lastMonth > metrics.maintenanceCostTwoMonths.thisMonth
                                        }"><i class="fa" :class="{
                                          'fa-arrow-up': metrics.maintenanceCostTwoMonths.thisMonth > metrics.maintenanceCostTwoMonths.lastMonth,
                                          'fa-arrow-down': metrics.maintenanceCostTwoMonths.lastMonth > metrics.maintenanceCostTwoMonths.thisMonth
                                        }"></i> {{ metrics.maintenanceCostTwoMonths.lastMonthPercentage }}%</span>
              <span class="text-nowrap">Versus last month</span>
            </template>
          </stats-card>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--5">
      <b-row>
        <b-col>
          <motorbikes-table/>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
  import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
  import MetricsAPI from '../../api/metrics'
  import MotorbikesTable from "../Tables/MotorbikesTable";
  import { mapActions } from 'vuex';

  export default {
    beforeMount() {
      this.fetch()
      this.getDaysTwoMonths()
      this.getMaintenanceCostTwoMonths()
      this.getMotorbikesTwoMonths()
      this.getMileageTwoMonths()
    },
    components: {
      MotorbikesTable,
      RouteBreadCrumb
    },
    data() {
      return {
        metrics: {
          daysTwoMonths: { thisMonth: '', lastMonth: '' },
          motorbikesTwoMonths: { thisMonth: '', lastMonth: '' },
          mileageTwoMonths: { thisMonth: '', lastMonth: '', thisMonthMeters: '' },
          maintenanceCostTwoMonths: { thisMonth: '', lastMonth: '' }
        }
      }
    },
    methods: {
      ...mapActions({
        fetch: 'motorbikes/fetch'
      }),
      getMotorbikesTwoMonths() {
        MetricsAPI.motorbikesTwoMonth()
          .then(metric => {
            this.metrics.motorbikesTwoMonths = metric
            const percent = metric.thisMonth / metric.lastMonth * 100 - 100
            if (percent === Infinity) {
              this.metrics.motorbikesTwoMonths.lastMonthPercentage = 100
            } else {
              this.metrics.motorbikesTwoMonths.lastMonthPercentage = Math.abs(metric.thisMonth / metric.lastMonth * 100 - 100).toFixed()
            }
          })
      },
      getMileageTwoMonths() {
        MetricsAPI.mileageTwoMonth()
          .then(metric => {
            this.metrics.mileageTwoMonths = metric
            this.metrics.mileageTwoMonths.thisMonthMeters = metric.thisMonth / 1000
            this.metrics.mileageTwoMonths.lastMonthMeters = metric.lastMonth / 1000
            const percent = metric.thisMonth / metric.lastMonth * 100 - 100
            if (percent === Infinity) {
              this.metrics.mileageTwoMonths.lastMonthPercentage = 100
            } else if (isNaN(percent)) {
              this.metrics.mileageTwoMonths.lastMonthPercentage = 0
            } else {
              this.metrics.mileageTwoMonths.lastMonthPercentage = Math.abs(metric.thisMonth / metric.lastMonth * 100 - 100).toFixed()
            }
          })
      },
      getDaysTwoMonths() {
        MetricsAPI.daysTwoMonth()
          .then(metric => {
            this.metrics.daysTwoMonths = metric
            const percent = metric.thisMonth / metric.lastMonth * 100 - 100
            if (percent === Infinity) {
              this.metrics.daysTwoMonths.lastMonthPercentage = 100
            } else if (isNaN(percent)) {
              this.metrics.daysTwoMonths.lastMonthPercentage = 0
            } else {
              this.metrics.daysTwoMonths.lastMonthPercentage = Math.abs(metric.thisMonth / metric.lastMonth * 100 - 100).toFixed()
            }
          })
      },
      getMaintenanceCostTwoMonths() {
        MetricsAPI.maintenanceCostTwoMonth()
          .then(metric => {
            this.metrics.maintenanceCostTwoMonths = metric
            const percent = metric.thisMonth / metric.lastMonth * 100 - 100
            if (percent === Infinity) {
              this.metrics.maintenanceCostTwoMonths.lastMonthPercentage = 100
            } else if (isNaN(percent)) {
              this.metrics.maintenanceCostTwoMonths.lastMonthPercentage = 0
            } else {
              this.metrics.maintenanceCostTwoMonths.lastMonthPercentage = Math.abs(metric.thisMonth / metric.lastMonth * 100 - 100).toFixed()
            }
          })
      }
    }
  };
</script>
<style>
</style>
